import { Link } from 'react-router-dom';
import DramaCard from './DramaCard';
import { getNewDramas, getHotDramas } from '@/mocks/dramas';

export default function LatestUpdates() {
  const newDramas = getNewDramas();
  const hotDramas = getHotDramas();

  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="mb-12">
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
                最新上线
              </h2>
              <p className="text-sm text-foreground-500">最新更新的电视剧，追剧不落伍</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
            {newDramas.length > 0 ? (
              newDramas.map((drama) => (
                <DramaCard key={drama.id} drama={drama} />
              ))
            ) : (
              hotDramas.slice(0, 6).map((drama) => (
                <DramaCard key={drama.id} drama={drama} />
              ))
            )}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
                高分必看
              </h2>
              <p className="text-sm text-foreground-500">口碑炸裂的高分神剧，部部经典</p>
            </div>
            <Link
              to="/category/guochanju"
              className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
            {hotDramas.slice(0, 6).map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}